import { useCallback } from "react";
import { useSearchParams } from "react-router";

import type { Type } from "../..";

export type SearchParamsState = {
	// freeWordText: string;
	isActiveChecked: boolean;
	isCanceledChecked: boolean;
	isAcceptMailMagazineChecked: boolean;
	isLocalPaymentChecked: boolean;
	isHostReservationChecked: boolean;
	isDayTripChecked: boolean;
	plans: string[];
	rooms: string[];
	options: string[];
	discounts: string[];
};

export const useSearchParamsState = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	const getSearchParamsState = useCallback((): SearchParamsState => {
		return {
			isActiveChecked: searchParams.get("isActive") === "true",
			isCanceledChecked: searchParams.get("isCanceled") === "true",
			isAcceptMailMagazineChecked: searchParams.get("isAcceptMailMagazine") === "true",
			isLocalPaymentChecked: searchParams.get("isLocalPayment") === "true",
			isHostReservationChecked: searchParams.get("isHostReservation") === "true",
			isDayTripChecked: searchParams.get("isDayTrip") === "true",
			plans: searchParams.getAll("plans"),
			rooms: searchParams.getAll("rooms"),
			options: searchParams.getAll("options"),
			discounts: searchParams.getAll("discounts"),
		};
	}, [searchParams]);

	const updateSearchParamsState = useCallback(
		(updates: Partial<Type.SearchModel>) => {
			const newParams = new URLSearchParams(searchParams);

			// 単一の値の更新
			if (updates.freeWordText !== undefined) {
				if (!updates.freeWordText) {
					newParams.delete("freeWord");
					return;
				}

				newParams.set("freeWord", updates.freeWordText);
			}

			// ブール値の更新
			const booleanParams = {
				isActive: updates.isActiveChecked,
				isCanceled: updates.isCanceledChecked,
				isAcceptMailMagazine: updates.isAcceptMailMagazineChecked,
				isLocalPayment: updates.isLocalPaymentChecked,
				isHostReservation: updates.isHostReservationChecked,
				isDayTrip: updates.isDayTripChecked,
			};

			Object.entries(booleanParams).forEach(([key, value]) => {
				if (value !== undefined) {
					if (!value) {
						newParams.delete(key);
						return;
					}

					newParams.set(key, "true");
				}
			});

			// 配列の更新
			if (updates.reservation) {
				const arrayUpdates = {
					plans: updates.reservation.plans?.filter((p) => p.checked).map((p) => p.id),
					rooms: updates.reservation.rooms?.filter((r) => r.checked).map((r) => r.id),
					options: updates.reservation.options?.filter((o) => o.checked).map((o) => o.id),
					discounts: updates.reservation.discounts?.filter((d) => d.checked).map((d) => d.id),
				};

				Object.entries(arrayUpdates).forEach(([key, values]) => {
					if (values) {
						newParams.delete(key);
						values.forEach((value) => newParams.append(key, value));
					}
				});
			}

			setSearchParams(newParams, { preventScrollReset: true });
		},
		[searchParams, setSearchParams],
	);

	return {
		searchParamsState: getSearchParamsState(),
		updateSearchParamsState,
	};
};
